<template>
  <AuthLayout class="page-auth">
    <form action="#" @submit.prevent="submit">
      <input type="text" autocomplete="name" :placeholder="$t('name')" v-model="name" required />
      <input type="text" autocomplete="surname" :placeholder="$t('surname')" v-model="surname" required />
      <input type="email" autocomplete="email" :placeholder="$t('email')" v-model="login" required />
      <input type="password" autocomplete="new-password" :placeholder="$t('password')" v-model="password" required />

      <terms required />

      <div class="page-auth__actions">
        <button class="primary large" type="submit">{{ $t('signUp') }}</button>
        <router-link to="/auth">
          <button class="gray large" type="button">{{ $t('logIn') }}</button>
        </router-link>
      </div>

      <div class="page-auth__sub-actions">
<!--        <a :href="`/Manual_for_participants_${$i18n.locale === 'ru' ? 'ru': 'en'}.pdf`" download class="btn-outline">-->
<!--          <img src="@/assets/icons/doc.svg" alt="scg">-->
<!--          <span v-text="$t('pages.auth.download-manual')"/>-->
<!--        </a>-->
        <a :href="`/Manual_for_participants_${$i18n.locale}.pdf`" download class="btn-outline">
          <img src="@/assets/icons/doc.svg" alt="scg">
          <span v-text="$t('pages.auth.download-manual')"/>
        </a>
      </div>

      <div class="error-block" v-if="error.length">
        <p v-for="errorMsg in error" :key="errorMsg">
          {{ errorMsg }}
        </p>
      </div>
    </form>
  </AuthLayout>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
import AuthLayout from '@/components/auth/Authlayout'
import Terms from '@/components/auth/terms'
import { mapMutations } from 'vuex'

export default {
  name: 'SignUp',
  components: { Terms, AuthLayout, Checkbox },
  data: () => ({
    name: '',
    surname: '',
    login: '',
    password: '',
    error: [],
  }),
  methods: {
    submit() {
      this.error = []

      this.$auth
        .register({
          data: {
            first_name: this.name,
            last_name: this.surname,
            email: this.login,
            password: this.password,
          },
        })
        .then((data) => {
          /*if (!this.login.includes('@huawei.')) {
            return this.openModal('account-moderation')
          }*/
          this.openModal('account-moderation')
          // this.$auth.login({
          //   data: {
          //     email: this.login,
          //     password: this.password,
          //   },
          // })
        })
        .catch((e) => {
          if (e.response.status === 413) {
            this.error.push(this.$t('SignUp.error413'))
          } else if (e.response?.data?.hasOwnProperty('errors')) {
            for (let field in e.response.data.errors) {
              for (let i = 0; i < e.response.data.errors[field].length; i++) {
                this.error.push(e.response.data.errors[field][i])
              }
            }
          } else {
            this.error.push(this.$t('SignUp.serverError'))
          }
        })
    },
    ...mapMutations(['openModal']),
  },
}
</script>
